module.exports = __webpack_public_path__ + "static/mongodb_icon-443bb2f96372e7e00b3a4bb26dead589.png";